import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "block text-xs font-semibold text-neutral-600" }
const _hoisted_3 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_4 = { class: "relative mt-2 rounded" }
const _hoisted_5 = ["for"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 left-0 z-10 w-3 h-full bg-white" }, null, -1)
const _hoisted_7 = ["name", "id", "accept", "placeholder", "value", "required", "readonly"]
const _hoisted_8 = {
  key: 0,
  class: "text-[10px] text-gray-600 mt-1"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FileInput',
  props: {
    modelValue: {
        default: null,
        required: true,
    },
    helper: {
        type: String,
        default: null,
    },
    error: {
        type: String,
        default: null,
    },
    placeholder: {
        type: String,
        default: null,
    },
    name: {
        type: String,
        default: null,
    },
    id: {
        type: String,
        default: null,
    },
    label: {
        type: String,
        default: null,
    },
    required: {
        type: Boolean,
        default: false,
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    customClass: {
        type: String,
        default: "",
    },
    accept: {
        type: String,
        default: "image/*",
    },
    trailingIcon: {
        type: String,
        default: null,
    },
    trailingIconClass: {
        type: String,
        default: null,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(__props.label) + " ", 1),
      (__props.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", {
        for: __props.id,
        class: _normalizeClass(["relative block w-full h-12 py-3 pl-4 pr-3 overflow-hidden border rounded cursor-pointer disabled:bg-gray-100 focus:outline-none focus:ring-0 text-neutral-600 placeholder:font-medium placeholder-neutral-400 border-neutral-100 focus:border-neutral-900", [__props.customClass]])
      }, [
        _hoisted_6,
        _createElementVNode("input", {
          name: __props.name,
          id: __props.id,
          accept: __props.accept,
          type: "file",
          class: "absolute left-[-96px] top-2.5 text-neutral-600 focus:outline-none focus:ring-0",
          placeholder: __props.placeholder,
          value: __props.modelValue,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
          required: __props.required,
          readonly: __props.readonly
        }, null, 40, _hoisted_7)
      ], 10, _hoisted_5),
      (__props.trailingIcon)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([__props.trailingIconClass, "absolute inset-y-0 right-0 z-50 flex items-center pr-3 cursor-pointer"])
          }, [
            (__props.trailingIcon)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.trailingIcon), {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('iconClick'))),
                  "aria-hidden": "true",
                  class: "w-5 h-5 text-gray-400"
                }))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    (__props.helper)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.helper), 1))
      : _createCommentVNode("", true),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: _normalizeClass(["text-[10px] mt-1", __props.error ? 'text-red-600' : 'text-gray-800']),
          id: "email-error"
        }, _toDisplayString(__props.error), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})